import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { GlobalSpinner } from "../../../../../global/globalFunctions";
import { addSize } from "./Size.action";
import { setHeading } from "../../../accounts/account.actions";
import _ from "lodash";
import Swal from "sweetalert";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const AddSize = (props) => {
  const [size, setSize] = useState("");
  const [sizeDesc, setSizeDesc] = useState("");
  const [visibleAlert, setAlertVisible] = useState(false);
  const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);


  function SaveSize() {
    props.addSize({
      sizeName: size,
      sizeDesc: sizeDesc,
    },
      handleVisible,
      handleDangerVisible
    );
    setSizeDesc("");
    setSize("")
  }
  const handleVisible = (msg) => {
    setAlertVisible(true);
    setTimeout(() => {
      setAlertVisible(false);
    }, 9000);
    Swal({
      title: "Success",
      text: msg,
      icon: "success",
      button: "Ok",
    });
  };
  const handleDangerVisible = (err) => {
    setDangerVisibleAlert(true);
    setTimeout(() => {
      setDangerVisibleAlert(false);
    }, 9000);
    Swal({
      title: "Error",
      text: err,
      icon: "error",
      button: "Ok",
    });
  };

  useEffect(() => {
    props.setHeading("Add Size");
  }, []);

  return (
    <>
      {props.isAddingSize ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Size Name *</b></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Size Name"
                  onChange={(e) => setSize(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Size Description :</b></Form.Label>
                <Form.Control
                  type="text"
                  value={sizeDesc}
                  placeholder="Size Description"
                  onChange={(e) => setSizeDesc(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="sendDiv">
            {_.isEmpty(size) ? (
              <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
            ) : (
              <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveSize}> SAVE </Button>
            )}
          </div>

        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    addSize: (data, handleVisible, handleDangerVisible) => dispatch(addSize(data, handleVisible, handleDangerVisible)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isAddingSize: state.sizeReducer.isAddingSize,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddSize);
